<template>
  <div class="about">
    <NavbarComp />
    <!-- <div class="container-1 mt-4 row">
      <div class="col">
        <img :src="about.image" alt="" />
      </div>
      <div class="col">
        <h3 class="titleI">{{ about.title }}</h3>
        <h6 class="descI" v-html="about.description"></h6>
      </div>
    </div>
    <div class="container-2 mt-5">
      <h1>MEET OUR TEAM</h1>
      <div class="row mt-3 card-about">
        <div class="col-lg-auto mb-3" v-for="(item, index) in staff" :key="index">
          <div class="card" style="width: 18rem">
            <div class="card-header">
              <h1>{{ item.position }}</h1>
            </div>
            <div class="card-body">
              <div class="bg-image" :style="`background-image : url(${item.image})`"></div>
              <h6 class="card-title">{{ item.name }}</h6>
              <h6 class="card-text">{{ item.job }}</h6>
              <a :href="item.linkedin" target="_blank"><img class="img" src="../assets/linkedin.png" alt="" /></a>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row container-1 m-0 py-5 py-lg-auto">
      <div class="col-lg-5 text-center">
        <img src="../assets/LogoIntelligo.png" alt="" />
      </div>
      <div class="col-lg-5">
        <h3 class="titleI">Intelligo.id</h3>
        <h6 class="descI">
          Intelligo ID adalah sebuah platform edutech yang hadir untuk mengatasi
          masalah dalam belajar dan menjadi solusi IT Service di bidang Web
          Development & Data Science, sehingga Intelligo ID dapat menjadi
          Learning & Assistant dalam proses belajar dan IT Service.
        </h6>
      </div>
    </div>
    <div class="container-2 mt-5">
      <h1>MEET OUR TEAM</h1>
      <div class="row card-about d-flex flex-wrap justify-content-center mt-5">
        <!-- Card 1 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body text-center">
              <img class="card-img-top" src="../assets/picAbout.png" />
              <h6 class="card-title">Muhammad Fahmi</h6>
              <h6 class="card-text text-center fs-6">
                CEO & Founder INTELLIGO.ID
              </h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 2 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout2.png" />
              <h6 class="card-title">Harun Ar - Rasyid</h6>
              <h6 class="card-text fs-6 text-center">
                Chief Technology Officer (CTO)
              </h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 3 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout3.png" />
              <h6 class="card-title">M Dzihan Al - Banna</h6>
              <h6 class="card-text fs-6 text-center">
                Chief Marketing Officer (CMO)
              </h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 4 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout4.png" />
              <h6 class="card-title">Nanda Harsana</h6>
              <h6 class="card-text fs-6 text-center">
                Data Scientist & Finance
              </h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 5 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout5.png" />
              <h6 class="card-title">Fahira</h6>
              <h6 class="card-text fs-6 text-center">
                Sosial Media Specialist
              </h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 6 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout6.png" />
              <h6 class="card-title">Paskah Prabu</h6>
              <h6 class="card-text fs-6 text-center">Content Creator</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 7 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout7.png" />
              <h6 class="card-title">Kadek Diva</h6>
              <h6 class="card-text fs-6 text-center">Full Stack Developer</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 8 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout8.png" />
              <h6 class="card-title">Bachtiar Ramadhan</h6>
              <h6 class="card-text fs-6 text-center">Data Scientist</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 9 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout9.png" />
              <h6 class="card-title">Helna Freecenta</h6>
              <h6 class="card-text fs-6 text-center">Data Scientist</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 10 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout10.png" />
              <h6 class="card-title">Katarina Kanti</h6>
              <h6 class="card-text fs-6 text-center">Brand Management</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 11 -->
        <div class="col-lg-auto mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout11.png" />
              <h6 class="card-title">Andika Risky Sururi</h6>
              <h6 class="card-text fs-6 text-center">Product Manager</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterComp />
  </div>
</template>
<!-- coba gitlab -->
<script>
import NavbarComp from "../components/NavbarComp.vue";
import FooterComp from "../components/FooterComp.vue";
export default {
  name: `AboutUs`,
  components: {
    NavbarComp,
    FooterComp,
  },
  data() {
    return {
      about: {},
      staff: [],
    };
  },
  methods: {
    fungsiLoadPage: async function () {
      this.about = (await this.$api.get(`/about`)).data.data;
    },
    fungsiLoadStaff: async function () {
      this.staff = (await this.$api.get(`/staff`)).data.data;
    },
  },
  mounted() {
    this.fungsiLoadPage();
    this.fungsiLoadStaff();
  },
};
</script>

<style>
.container-1 {
  padding: 100px 100px;
}
.about .container-1 img {
  width: 417px;
  height: 254px;
}

.titleI {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #ff5400;
}

.descI {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #023047;
}

.about .container-2 h1 {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: #ff5400;
}

.about .container-2 .card-about {
  margin-left: 45px;
}

.about .container-2 .card {
  border: none;
  text-align: center;
  margin-bottom: 15px;
}

.about .container-2 .card-header {
  border: none;
  background-color: transparent;
}

.about .container-2 .card-header h1 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.005em;
  color: #02283b;
}

.about .container-2 .card-body {
  border: none;
  background: #f5f5f5;
  border-radius: 16px;
}

.about .container-2 .card-body .card-title {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #ff5400;
  margin-top: 20px;
}

.about .container-2 .card-body .card-text {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #023047;
  margin-top: -2px;
}

.about .container-2 .card-body .img {
  width: 40px;
  margin-top: 15px;
}

.about .container-2 .card-img-top {
  width: 120px;
  height: 120px;
}

.bg-image {
  width: 100%;
  height: 254px;
  background-size: cover;
}

@media only screen and (max-width: 1024px) {
  .about .container-1 img {
    width: 70%;
    height: 100%;
  }

  .container-1 {
    padding: 0;
  }

  .about .container-2 .card-about {
    margin-left: 0;
    margin-right: 0 !important;
  }

  .descI {
    font-size: 16px;
  }

  .about .container-2 .card {
    width: 100% !important;
  }
}
</style>
